import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  DateTime,
} from 'luxon';
import i18n from 'i18next';

import {
  Modal,
  Button,
  Select,
  TextField,
  DatePickerField,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const selectProps = {
  styles: {
    container: provided => ({
      ...provided,
      width: '100%',
    }),
    menu: provided => ({
      ...provided,
      marginTop: '1px',
    }),
  },
  theme: theme => ({
    ...theme,
    borderRadius: 3,
  }),
};

interface Props {
  isOpen: boolean,
  clients: any[],
  startDate: Date,
  initialClient: number,
  initialValues: any,
  onSubmit: { (values: any, actions: any): void },
  onRequestClose: { (): void },
}

const NewActivityLogger = ({
  isOpen,
  startDate,
  clients,
  initialClient,
  initialValues,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title="Activity Logger"
    isOpen={isOpen}
    contentStyle={{ width: 400 }}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={initialValues || {
        person_id: initialClient,
        begins_at: DateTime.fromJSDate(startDate),
        ends_at: DateTime.fromJSDate(startDate).plus({ hours: 1 }),
        workout_name: '',
        description: '',
      }}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <Flex
          as="form"
          column
          width="100%"
          onSubmit={formikProps.handleSubmit}
        >
          {initialValues?.id === undefined && (
            <Flex width="100%" column>
              <S.Label htmlFor="person_id-select">
                {i18n.t('client')}
              </S.Label>
              <Select
                {...selectProps}
                id="person_id-select"
                value={clients
                  ? clients.find(option => option.value === String(formikProps.values.person_id))
                  : ''}
                name="person_id"
                options={clients}
                onChange={(option: any) => {
                  formikProps.setFieldValue('person_id', option.value);
                }}
              />
            </Flex>
          )}
          <Flex width="100%" spacing={10}>
            <Flex column>
              <S.Label>
                Start
              </S.Label>
              <Field
                name="begins_at"
                dateFormat="MM/dd/yyyy   hh:mm a"
                showTimeSelect
                minDate={new Date()}
                onChange={(date: Date) => {
                  const start = DateTime.fromJSDate(date);
                  formikProps.setFieldValue('begins_at', start);
                  formikProps.setFieldValue('ends_at', start.plus({ hours: 1 }));
                }}
                component={DatePickerField}
              />
            </Flex>
            <Flex column>
              <S.Label>
                End
              </S.Label>
              <Field
                name="ends_at"
                selected={new Date(formikProps.values.begins_at.toISO())}
                dateFormat="MM/dd/yyyy   hh:mm a"
                showTimeSelect
                minDate={new Date(formikProps.values.begins_at.toISO())}
                onChange={(date: Date) => {
                  formikProps.setFieldValue('ends_at', DateTime.fromJSDate(date));
                }}
                component={DatePickerField}
              />
            </Flex>
          </Flex>
          <Flex width="100%" column>
            <S.Label>
              Activity Name
            </S.Label>
            <Field
              name="workout_name"
              component={TextField}
              placeholder="Enter name"
            />
          </Flex>
          <Flex width="100%" column>
            <S.Label>
              Description
            </S.Label>
            <Field
              name="description"
              textarea
              minRows={4}
              placeholder="Enter a description (optional)"
              component={TextField}
            />
          </Flex>
          <S.Footer>
            <hr />
            <Flex width="100%" justify="flex-end" spacing={20}>
              <Button
                ghost
                appearance="danger"
                onClick={onRequestClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                appearance="primary"
                isLoading={formikProps.isSubmitting}
                isDisabled={
                  formikProps.isSubmitting
                  || !formikProps.values.person_id
                  || !formikProps.values.begins_at
                  || !formikProps.values.ends_at
                }
              >
                Save
              </Button>
            </Flex>
          </S.Footer>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default NewActivityLogger;
